/* eslint-disable */
/*
 * jQuery myCart - v1.7 - 2018-03-07
 * http://asraf-uddin-ahmed.github.io/
 * Copyright (c) 2017 Asraf Uddin Ahmed; Licensed None
 */
import $ from 'jquery'
;(function ($) {
  'use strict'

  var OptionManager = (function () {
    var objToReturn = {}

    var _options = null
    var DEFAULT_OPTIONS = {
      currencySymbol: '$',
      classCartIcon: 'my-cart-icon',
      classCartBadge: 'my-cart-badge',
      classProductQuantity: 'my-product-quantity',
      classProductRemove: 'my-product-remove',
      classCheckoutCart: 'my-cart-checkout',
      affixCartIcon: true,
      showCheckoutModal: true,
      numberOfDecimals: 2,
      cartItems: null,
      clickOnAddToCart: function ($addTocart) {},
      afterAddOnCart: function (products) {},
      clickOnCartIcon: function ($cartIcon, products) {},
      checkoutCart: function (products) {
        return false
      },
    }

    var loadOptions = function (customOptions) {
      _options = $.extend({}, DEFAULT_OPTIONS)
      if (typeof customOptions === 'object') {
        $.extend(_options, customOptions)
      }
    }
    var getOptions = function () {
      return _options
    }

    objToReturn.loadOptions = loadOptions
    objToReturn.getOptions = getOptions
    return objToReturn
  })()

  var MathHelper = (function () {
    var objToReturn = {}
    var getRoundedNumber = function (number) {
      if (isNaN(number)) {
        throw new Error('Parameter is not a Number')
      }
      number = number * 1
      var options = OptionManager.getOptions()
      return number.toFixed(options.numberOfDecimals)
    }
    objToReturn.getRoundedNumber = getRoundedNumber
    return objToReturn
  })()

  var ProductManager = (function () {
    var objToReturn = {}

    /*
      PRIVATE
      */
    localStorage.products = localStorage.products ? localStorage.products : ''
    var getIndexOfProduct = function (id) {
      var productIndex = -1
      var products = getAllProducts()
      $.each(products, function (index, value) {
        if (value.id == id) {
          productIndex = index
          return
        }
      })
      return productIndex
    }
    var setAllProducts = function (products) {
      localStorage.products = JSON.stringify(products)
    }
    var addProduct = function (id, name, summary, application, strength, span, spantype, windzone, roofload, rafterspacing) {
      var products = getAllProducts()
      products.push({
        id: id,
        name: name,
        summary: summary,
        application: application,
        strength: strength,
        span: span,
        spantype: spantype,
        windzone: windzone,
        roofload: roofload,
        rafterspacing: rafterspacing,
      })
      setAllProducts(products)
    }

    /*
      PUBLIC
      */
    var getAllProducts = function () {
      try {
        var products = JSON.parse(localStorage.products)
        return products
      } catch (e) {
        return []
      }
    }
    var updatePoduct = function (id, quantity) {
      var productIndex = getIndexOfProduct(id)
      if (productIndex < 0) {
        return false
      }
      var products = getAllProducts()

      return true
    }
    var setProduct = function (id, name, summary, application, strength, span, spantype, windzone, roofload, rafterspacing) {
      if (typeof id === 'undefined') {
        console.error('id required')
        return false
      }
      if (typeof name === 'undefined') {
        console.error('name required')
        return false
      }

      summary = typeof summary === 'undefined' ? '' : summary
      application = typeof application === 'undefined' ? '' : application
      strength = typeof strength === 'undefined' ? '' : strength
      span = typeof span === 'undefined' ? '' : span
      spantype = typeof spantype === 'undefined' ? '' : spantype
      windzone = typeof windzone === 'undefined' ? '' : windzone
      roofload = typeof roofload === 'undefined' ? '' : roofload
      rafterspacing = typeof rafterspacing === 'undefined' ? '' : rafterspacing

      if (!updatePoduct(id)) {
        addProduct(id, name, summary, application, strength, span, spantype, windzone, roofload, rafterspacing)
      }
    }
    var clearProduct = function () {
      setAllProducts([])
    }
    var removeProduct = function (id) {
      var products = getAllProducts()
      products = $.grep(products, function (value, index) {
        return value.id != id
      })
      setAllProducts(products)
    }

    objToReturn.getAllProducts = getAllProducts
    objToReturn.updatePoduct = updatePoduct
    objToReturn.setProduct = setProduct
    objToReturn.clearProduct = clearProduct
    objToReturn.removeProduct = removeProduct
    return objToReturn
  })()

  var loadMyCartEvent = function (targetSelector) {
    var options = OptionManager.getOptions()
    var $cartIcon = $('.' + options.classCartIcon)
    var $cartBadge = $('.' + options.classCartBadge)
    var classProductQuantity = options.classProductQuantity
    var classProductRemove = options.classProductRemove
    var classCheckoutCart = options.classCheckoutCart

    var idCartModal = 'my-cart-modal'
    var idCartTable = 'my-cart-table'
    var idGrandTotal = 'my-cart-grand-total'
    var idEmptyCartMessage = 'my-cart-empty-message'
    var idDiscountPrice = 'my-cart-discount-price'
    var classProductTotal = 'my-product-total'
    var classAffixMyCartIcon = 'my-cart-icon-affix'

    if (options.cartItems && options.cartItems.constructor === Array) {
      ProductManager.clearProduct()
      $.each(options.cartItems, function () {
        ProductManager.setProduct(this.id, this.name, this.summary, this.application, this.strength, this.span, this.spantype, this.windzone, this.roofload, this.rafterspacing)
      })
    }

    var drawTable = function () {
      var $cartTable = $('#' + idCartTable)
      $cartTable.empty()

      var products = ProductManager.getAllProducts()
      $.each(products, function () {
        // var total = this.quantity * this.price;
        $cartTable.append('<tr title="' + this.summary + '" data-id="' + this.id + '">' + '<td data-label="Product">' + this.name + '</td>' + '<td data-label="Application">' + this.application + '</td>' + '<td data-label="Beam Size">' + this.summary + '</td>' + '<td data-label="Strength">' + this.strength + '</td>' + '<td data-label="Span Type">' + this.spantype + '</td>' + '<td data-label="Parameter">' + this.windzone + ',' + this.roofload + ',' + this.rafterspacing + '</td>' + '<td data-label="Result (mm)">' + this.span + '</td>' + '<td data-label=" " title="Remove from Cart" class="text-center" style="width: 30px;"><a href="javascript:void(0);" class="btn btn-xs btn-danger ' + classProductRemove + '">X</a></td>' + '</tr>')
      })
    }
    var showModal = function () {
      drawTable()
    }

    /*
      EVENT
      */
    // if (options.affixCartIcon) {
    //   var cartIconBottom = $cartIcon.offset().top * 1 + $cartIcon.css("height").match(/\d+/) * 1;
    //   var cartIconPosition = $cartIcon.css('position');
    //   $(window).scroll(function () {
    //     $(window).scrollTop() >= cartIconBottom ? $cartIcon.addClass(classAffixMyCartIcon) : $cartIcon.removeClass(classAffixMyCartIcon);
    //   });
    // }

    $cartIcon.click(function () {
      options.showCheckoutModal ? showModal() : options.clickOnCartIcon($cartIcon, ProductManager.getAllProducts())
    })

    $(document).on('click', '.' + classProductRemove, function () {
      var $tr = $(this).closest('tr')
      var id = $tr.data('id')
      $tr.hide(500, function () {
        ProductManager.removeProduct(id)
        $('#list-rafter input[type=checkbox]:checked').each(function (i) {
          var $target = $(this)

          var checkboxDataID = $target.data('id')

          if (checkboxDataID == id) {
            this.removeAttribute('checked') // For other browsers
            this.checked = false
          } else {
            this.setAttribute('checked', '') // For IE
            this.checked = true
          }
        })
        drawTable()
      })
    })

    $('#list-rafter input[type=checkbox]').on('click', targetSelector, function () {
      if (this.checked) {
        //Do stuff
        var $target = $(this)
        options.clickOnAddToCart($target)
        var id = $target.data('id')
        var name = $target.data('name')
        var summary = $target.data('summary')
        var application = $target.data('application')
        var strength = $target.data('strength')
        var span = $target.data('span')
        var spantype = $target.data('spantype')
        var windzone = $target.data('windzone')
        var roofload = $target.data('roofload')
        var rafterspacing = $target.data('rafterspacing')

        ProductManager.setProduct(id, name, summary, application, strength, span, spantype, windzone, roofload, rafterspacing)
        options.afterAddOnCart(ProductManager.getAllProducts())
        this.setAttribute('checked', '') // For IE
        // this.removeAttribute("checked"); // For other browsers
        this.checked = true
      } else {
        ProductManager.clearProduct()
        this.removeAttribute('checked') // For other browsers

        // $('#reportCheckbox').attr('checked', false); // Unchecks it
        this.checked = false
      }
    })

    $('#resetReport').on('click', function () {
      $('#my-cart-table').empty()
      // $('.viewReportlist').hide();
      $('#reportCheckbox').myCart({
        cartItems: [],
      })

      $('#list-rafter input[type=checkbox]:checked').each(function (i) {
        this.removeAttribute('checked') // For other browsers
        this.checked = false
      })
    })
  }

  $.fn.myCart = function (userOptions) {
    OptionManager.loadOptions(userOptions)
    loadMyCartEvent(this.selector)
    return this
  }
})($)
